import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import * as toastr from 'toastr';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-new-local-customer-anagraf',
  templateUrl: './new-local-customer-anagraf.component.html',
  styleUrls: ['./new-local-customer-anagraf.component.scss']
})
export class NewLocalCustomerAnagrafComponent  extends ProjectConstants implements OnInit, OnDestroy {

  localCustomer: LocalCustomerModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router,
              private localCustomerService: LocalCustomerAnagrafService,
              private loaderService: LoaderService) {
    super();

    this.localCustomer = new LocalCustomerModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.localCustomer.cod, [Validators.required]],
      description: [this.localCustomer.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.LOCAL_CUSTOMER_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    this.submitted = true;
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.localCustomer.cod = this.formValidator.value.cod;
      this.localCustomer.description = this.formValidator.value.description;
      this.saveSubscribe = this.localCustomerService.save(this.localCustomerService.baseUrl, this.localCustomer).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Local Customer Cod already exists', 'Warning');
          } else {
            toastr.success('Local customer was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.LOCAL_CUSTOMER_ANAGRF]);
          }
        }, error => {
          this.loaderService.display(false);
          toastr.error('Local Customer was not added', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get fv() { return this.formValidator.controls; }

}
